
import React from 'react'

const CaptureSvgSvg = () => {
  return (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M9.16699 9.16683C9.16699 8.15431 9.98778 7.3335 11.0003 7.3335C12.0129 7.3335 12.8337 8.15431 12.8337 9.16683C12.8337 10.1794 12.0129 11.0002 11.0003 11.0002C9.98778 11.0002 9.16699 10.1794 9.16699 9.16683Z" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.0003 1.8335C6.95024 1.8335 3.66699 5.11674 3.66699 9.16683C3.66699 13.2169 6.95024 16.5002 11.0003 16.5002C15.0504 16.5002 18.3337 13.2169 18.3337 9.16683C18.3337 5.11674 15.0504 1.8335 11.0003 1.8335ZM11.0003 5.50016C8.97528 5.50016 7.33366 7.14178 7.33366 9.16683C7.33366 11.1918 8.97528 12.8335 11.0003 12.8335C13.0253 12.8335 14.667 11.1918 14.667 9.16683C14.667 7.14178 13.0253 5.50016 11.0003 5.50016Z" fill="white"/>
<path d="M6.65572 16.1816L6.14183 16.8668C5.12208 18.2265 6.09223 20.1668 7.79183 20.1668H14.2085C15.9081 20.1668 16.8782 18.2265 15.8585 16.8668L15.3446 16.1816C14.0829 16.9647 12.5943 17.4168 11.0001 17.4168C9.40593 17.4168 7.91741 16.9647 6.65572 16.1816Z" fill="white"/>
</svg>

  )
}

export default CaptureSvgSvg

